import { AppState } from '@/store/state';
import { ToggleSidebarMenu } from '@/store/ui/actions';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { MultitenantService } from '@services/multitenant.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-super-admin-main-component',
  templateUrl: './super-admin-main-component.component.html',
  styleUrl: './super-admin-main-component.component.scss'
})
export class SuperAdminMainComponentComponent {
  totalRecords: number = 0;
  pageSize: number = 10;
  currentPage: number = 1;
  public data: any[] = [];
  public name: string = "";
  public loading = true;
  public displayDetailBox: boolean = false;
  public tenantDetail: any
  constructor(
    private tenantService: MultitenantService,
    private renderer: Renderer2,
    private toaster: ToastrService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {
    this.getTenantList()
  }
  getTenantList() {
    //this.loading = true;
    this.tenantService.getTenantlist(this.currentPage, this.pageSize).subscribe(
      result => {
        this.totalRecords = result.totalRecords;
        this.data = result.users;
        console.log(this.data);
        this.loading = false;

      }
    );
  }
  onToggleMenuSidebar() {
    this.store.dispatch(new ToggleSidebarMenu());
  }
  onPageChange(event: any) {
    this.currentPage = event.page + 1; // PrimeNG paginator starts from 0
    this.getTenantList();
  }
  detailNotification(id: any) {
    this.displayDetailBox = true;
    console.log(id);
    this.tenantService.getTenantById(id).subscribe(
      result => {
        this.tenantDetail = result;
        console.log(this.tenantDetail);

      }
    );
  }
  closePopup(){
    this.displayDetailBox = false;
  }

  activateTenant(tenantDetail:any){
    this.tenantService.activateTenant(tenantDetail).subscribe(
      result => {
        this.toaster.success("Tenant Activated Successfully !")
        this.displayDetailBox = false;
      }
    );

  }
}
